export default "__VITE_ASSET__Bjr55RZc__"